import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Itinerary from "@/pages/Itinerary";
import DayDetail from "@/pages/DayDetail";
import Checklist from "@/pages/Checklist";
import Diary from "@/pages/Diary";
import MapPage from "@/pages/MapPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF8F4] text-[#1D3A4C]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/itinerario" element={<Itinerary />} />
            <Route path="/giorno/:id" element={<DayDetail />} />
            <Route path="/checklist" element={<Checklist />} />
            <Route path="/diario" element={<Diary />} />
            <Route path="/mappa" element={<MapPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1D3A4C",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.1)",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
